import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Test from "./page/test";

import Login from "./page/login";
import ResendVerification from "./page/resend-verification";
import SettlementVerification from "./page/settlement-verification";
import DepositTest from "./page/deposit-test";
import PayPrimerlo from "./page/pay-primerlo";
import Kyc from "./page/kyc";
import DocumentAPI from "./page/document_api";
import PolicyPrivacy from "./page/policy_privacy.js";
import Verify from "./page/verify.js";
import Verify2FA from "./page/verify2fa.js";
import ResetPassword from "./page/reset-password.js";
import ChangePassword from "./page/change-password.js";

// SHARED
import ConnectAPIs from "./page/shared/connect_apis.js";
import Settings from "./page/shared/settings.js";

// SUPER USER / ADMIN
import AdminDashboard from "./page/super_user/dashboard.js";
import AdminDepositsWithdrawals from "./page/super_user/deposits-withdraws.js";
import AdminSettlementsHQ from "./page/super_user/settlements-hq.js";
import AdminBrokers from "./page/super_user/brokers.js";
import AdminCustomers from "./page/super_user/customers.js";
import AdminUsers from "./page/super_user/users.js";
import AdminAgents from "./page/super_user/agents.js";
import AdminGatewayReports from "./page/super_user/gateway-reports.js";
import AdminGatewayGmvUsage from "./page/super_user/gateway-gmv-usage.js";
import AdminFlowMap from "./page/super_user/flow-map.js";
import AdminGmvMonitor from "./page/super_user/gmv-monitor.js";
import AdminAnnualProfits from "./page/super_user/annual-profits.js";
import AdminMonthlies from "./page/super_user/monthlies.js";
import AdminMonthlyDev from "./page/super_user/monthly-devs.js";
import AdminSettlements from "./page/super_user/settlements.js";
import AdminTransferMoneys from "./page/super_user/transfer-money.js";
import AdminTiers from "./page/super_user/tiers.js";
import AdminGateways from "./page/super_user/gateways.js";
import AdminRoles from "./page/super_user/roles.js";
import AdminCenterConfigs from "./page/super_user/center-configs.js";
import AdminLogs from "./page/super_user/logs.js";
import AdminWebhooks from "./page/super_user/webhooks.js";
import AdminCFRAccounts from "./page/super_user/cfr-accounts.js";
import AdminMisMatchs from "./page/super_user/mismatch.js";
import AdminReconciles from "./page/super_user/reconciles.js";
import AdminCommissionAgent from "./page/super_user/commission-agent.js";
import AdminTelegramRoom from "./page/super_user/telegram-rooms.js";
import AdminPhoneticMap from "./page/super_user/phonetic-maps.js";
import AdminHoliday from "./page/super_user/holidays.js";
import AdminInvoices from "./page/super_user/invoices.js";
import AdminTransactionAnalytics from "./page/super_user/transaction-analytics.js";
import AdminDeveloperMode from "./page/super_user/developer-mode.js";
import AdminOrderMarketplace from "./page/super_user/order-marketplace.js";
import AdminProducts from "./page/super_user/products.js";

// BROKER / SUB BROKER
import BrokerDashboard from "./page/broker/dashboard.js";
import BrokerDepositsWithdrawals from "./page/broker/deposits-withdraws.js";
import BrokerCustomers from "./page/broker/customers.js";
import BrokerSettlements from "./page/broker/settlements.js";
import BrokerSettlementsHQ from "./page/broker/settlements-hq.js";
import BrokerMisMatchs from "./page/broker/mismatch.js";
import BrokerInvoices from "./page/broker/invoices.js";
import BrokerWebhooks from "./page/broker/webhooks.js";

// AGENT
import AgentDashboard from "./page/agent/dashboard.js";
import AgentDepositsWithdrawals from "./page/agent/deposits-withdraws.js";
import AgentBrokers from "./page/agent/brokers.js";
import AgentCustomers from "./page/agent/customers.js";
import AgentCommissionAgent from "./page/agent/commission-agent.js";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>

    <Route path="/" element={<Login />} />
    <Route path="/test" element={<Test />} />
    <Route path="/resend-verification" element={<ResendVerification />} />
    <Route path="/settlement/verification/:id" element={<SettlementVerification />} />
    <Route path="/deposit-test" element={<DepositTest />} />
    <Route path="/pay/primerlo" element={<PayPrimerlo />} />
    <Route path="/kyc" element={<Kyc />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/change-password/:token" element={<ChangePassword />} />
    <Route path="/document-api" element={<DocumentAPI />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />
    <Route path="/verify/:token" element={<Verify />} />
    <Route path="/verify-2fa" element={<Verify2FA />} />

    {/* SHARED */}
    <Route path="/su/settings" element={<Settings />} />
    <Route path="/su/connect-apis" element={<ConnectAPIs />} />
    <Route path="/ad/settings" element={<Settings />} />
    <Route path="/ad/connect-apis" element={<ConnectAPIs />} />
    <Route path="/bk/settings" element={<Settings />} />
    <Route path="/bk/connect-apis" element={<ConnectAPIs />} />
    <Route path="/sb/settings" element={<Settings />} />
    <Route path="/sb/connect-apis" element={<ConnectAPIs />} />
    <Route path="/ag/settings" element={<Settings />} />
    <Route path="/ag/connect-apis" element={<ConnectAPIs />} />
    <Route path="/ac/settings" element={<Settings />} />
    <Route path="/ac/connect-apis" element={<ConnectAPIs />} />

    {/* SUPER USER */}
    <Route path="/su/dashboard" element={<AdminDashboard />} />
    <Route path="/su/deposits-withdrawals" element={<AdminDepositsWithdrawals />}/>
    <Route path="/su/settlements-hq" element={<AdminSettlementsHQ />} />
    <Route path="/su/brokers" element={<AdminBrokers />} />
    <Route path="/su/customers" element={<AdminCustomers />} />
    <Route path="/su/users" element={<AdminUsers />} />
    <Route path="/su/agents" element={<AdminAgents />} />
    <Route path="/su/gateway-reports" element={<AdminGatewayReports />} />
    <Route path="/su/gateway-gmv-usage" element={<AdminGatewayGmvUsage />} />
    <Route path="/su/flow-map" element={<AdminFlowMap />} />
    <Route path="/su/gmv-monitor" element={<AdminGmvMonitor />} />
    <Route path="/su/annual-profits" element={<AdminAnnualProfits />} />
    <Route path="/su/monthlies" element={<AdminMonthlies />} />
    <Route path="/su/monthly-devs" element={<AdminMonthlyDev />} />
    <Route path="/su/settlements" element={<AdminSettlements />} />
    <Route path="/su/transfer-moneys" element={<AdminTransferMoneys />} />
    <Route path="/su/tier-configs" element={<AdminTiers />} />
    <Route path="/su/gateway-rules" element={<AdminGateways />} />
    <Route path="/su/roles" element={<AdminRoles />} />
    <Route path="/su/center-configs" element={<AdminCenterConfigs />} />
    <Route path="/su/logs" element={<AdminLogs />} />
    <Route path="/su/webhooks" element={<AdminWebhooks />} />
    <Route path="/su/cfr-accounts" element={<AdminCFRAccounts />} />
    <Route path="/su/mismatchs" element={<AdminMisMatchs />} />
    <Route path="/su/reconciles" element={<AdminReconciles />} />
    <Route path="/su/commission-agents" element={<AdminCommissionAgent />} />
    <Route path="/su/telegram-rooms" element={<AdminTelegramRoom />} />
    <Route path="/su/phonetic-maps" element={<AdminPhoneticMap />} />
    <Route path="/su/holidays" element={<AdminHoliday />} />
    <Route path="/su/invoices" element={<AdminInvoices />} />
    <Route path="/su/transaction-analytics" element={<AdminTransactionAnalytics />} />
    <Route path="/su/developer-mode" element={<AdminDeveloperMode />} />
    <Route path="/su/order-marketplace" element={<AdminOrderMarketplace />} />
    <Route path="/su/products" element={<AdminProducts />} />

    {/* ADMIN */}
    <Route path="/ad/dashboard" element={<AdminDashboard />} />
    <Route path="/ad/deposits-withdrawals" element={<AdminDepositsWithdrawals />}/>
    <Route path="/ad/settlements-hq" element={<AdminSettlementsHQ />} />
    <Route path="/ad/brokers" element={<AdminBrokers />} />
    <Route path="/ad/customers" element={<AdminCustomers />} />
    <Route path="/ad/users" element={<AdminUsers />} />
    <Route path="/ad/agents" element={<AdminAgents />} />
    <Route path="/ad/gateway-reports" element={<AdminGatewayReports />} />
    <Route path="/ad/gateway-gmv-usage" element={<AdminGatewayGmvUsage />} />
    <Route path="/ad/flow-map" element={<AdminFlowMap />} />
    <Route path="/ad/gmv-monitor" element={<AdminGmvMonitor />} />
    <Route path="/ad/annual-profits" element={<AdminAnnualProfits />} />
    <Route path="/ad/monthlies" element={<AdminMonthlies />} />
    <Route path="/ad/monthly-devs" element={<AdminMonthlyDev />} />
    <Route path="/ad/settlements" element={<AdminSettlements />} />
    <Route path="/ad/transfer-moneys" element={<AdminTransferMoneys />} />
    <Route path="/ad/tier-configs" element={<AdminTiers />} />
    <Route path="/ad/gateway-rules" element={<AdminGateways />} />
    <Route path="/ad/roles" element={<AdminRoles />} />
    <Route path="/ad/center-configs" element={<AdminCenterConfigs />} />
    <Route path="/ad/logs" element={<AdminLogs />} />
    <Route path="/ad/webhooks" element={<AdminWebhooks />} />
    <Route path="/ad/cfr-accounts" element={<AdminCFRAccounts />} />
    <Route path="/ad/mismatchs" element={<AdminMisMatchs />} />
    <Route path="/ad/reconciles" element={<AdminReconciles />} />
    <Route path="/ad/commission-agents" element={<AdminCommissionAgent />} />
    <Route path="/ad/telegram-rooms" element={<AdminTelegramRoom />} />
    <Route path="/ad/phonetic-maps" element={<AdminPhoneticMap />} />
    <Route path="/ad/holidays" element={<AdminHoliday />} />
    <Route path="/ad/invoices" element={<AdminInvoices />} />
    <Route path="/ad/transaction-analytics" element={<AdminTransactionAnalytics />} />
    <Route path="/ad/developer-mode" element={<AdminDeveloperMode />} />
    <Route path="/ad/order-marketplace" element={<AdminOrderMarketplace />} />
    <Route path="/ad/products" element={<AdminProducts />} />

    {/* ACCOUNTING */}
    <Route path="/ac/dashboard" element={<AdminDashboard />} />
    <Route path="/ac/deposits-withdrawals" element={<AdminDepositsWithdrawals />} />
    <Route path="/ac/brokers" element={<AdminBrokers />} />
    <Route path="/ac/gateway-gmv-usage" element={<AdminGatewayGmvUsage />} />
    <Route path="/ac/gmv-monitor" element={<AdminGmvMonitor />} />
    <Route path="/ac/monthlies" element={<AdminMonthlies />} />
    <Route path="/ac/monthly-devs" element={<AdminMonthlyDev />} />
    <Route path="/ac/settlements" element={<AdminSettlements />} />
    <Route path="/ac/transfer-moneys" element={<AdminTransferMoneys />} />
    <Route path="/ac/mismatchs" element={<AdminMisMatchs />} />
    <Route path="/ac/reconciles" element={<AdminReconciles />} />
    <Route path="/ac/commission-agents" element={<AdminCommissionAgent />} />

    {/* BROKER */}
    <Route path="/bk/dashboard" element={<BrokerDashboard />} />
    <Route path="/bk/deposits-withdrawals" element={<BrokerDepositsWithdrawals />} />
    <Route path="/bk/settlements-hq" element={<BrokerSettlementsHQ />} />
    <Route path="/bk/customers" element={<BrokerCustomers />} />
    <Route path="/bk/settlements" element={<BrokerSettlements />} />
    <Route path="/bk/mismatchs" element={<BrokerMisMatchs />} />
    <Route path="/bk/invoices" element={<BrokerInvoices />} />
    <Route path="/bk/webhooks" element={<BrokerWebhooks />} />

    {/* SUB BROKER */}
   <Route path="/sb/dashboard" element={<BrokerDashboard />} />
    <Route path="/sb/deposits-withdrawals" element={<BrokerDepositsWithdrawals />} />
    <Route path="/sb/settlements-hq" element={<BrokerSettlementsHQ />} />
    <Route path="/sb/customers" element={<BrokerCustomers />} />
    <Route path="/sb/settlements" element={<BrokerSettlements />} />
    <Route path="/sb/mismatchs" element={<BrokerMisMatchs />} />
    <Route path="/sb/invoices" element={<BrokerInvoices />} />


    {/* AGENT */}
    <Route path="/ag/dashboard" element={<AgentDashboard />} />
    <Route path="/ag/deposits-withdrawals" element={<AgentDepositsWithdrawals />}/>
    <Route path="/ag/brokers" element={<AgentBrokers />} />
    <Route path="/ag/customers" element={<AgentCustomers />} />
    <Route path="/ag/commission-agents" element={<AgentCommissionAgent />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
